<template>
  <v-stepper-content step="4" class="pb-0">
    <v-alert v-if="timeLeft == 0 && $store.getters['game/timer']"  class="animated bounceIn" type="error">{{$t('general.timerMessage')}}</v-alert>
    <v-sheet
      class="text-center mb-1 card-title"
      color="primary"
      elevation="1"
      dark
    >{{$store.getters['company/productionCompany'] ? $t('steps.productionShipments') : $t('steps.supplierShipments')}}</v-sheet>
    <v-card class="pa-4" outlined v-if="$store.getters['company/productionCompany']" :class="{'test-mode' : $store.getters['game/test']}">
      <v-row align="center" class="animated bounceIn">
        <v-col cols="12" align="center">
          <v-img width="100%" max-width="300px" src="@/assets/icon/commande fournisseur.png"></v-img>
        </v-col>
        <v-col cols="12" align="center">
          <p
            style="font-size: 26px; font-weight: 900"
          >{{$tc('suppliersShipments.production', production, {nbr: production})}}</p>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="pa-4" outlined v-else :class="{'test-mode' : $store.getters['game/test']}">
      <v-row align="center">
        <v-col cols="3" align="center" class="animated bounceInLeft delay-1s">
          <v-row
            align="center"
            v-for="supplier in $store.getters['company/data'].suppliers"
            :key="supplier.supplier._id"
          >
            <v-col cols="6" align="center">
              <company-logo
                :name="supplier.supplier.name"
                :logo="filesUrl + 'logo/' + supplier.supplier.companieSettings.logo"
              ></company-logo>
            </v-col>
            <v-col cols="6">
              <span
                style="font-size: 28px"
              >{{$tc('general.units', supplier.receipts[supplier.receipts.length - 1], {nbr: supplier.receipts[supplier.receipts.length - 1]})}}</span>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="1" align="center" class="animated bounceInLeft delay-1s">
          <v-row>
            <v-col cols="12" align="center">
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="4" align="center" class="animated bounceIn">
          <v-row>
            <v-col cols="12" align="center">
              <v-img width="70%" src="@/assets/icon/maj stock.png"></v-img>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="2" align="center" class="animated bounceInRight delay-1s">
          <v-row>
            <v-col cols="12" align="center">
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="2" align="center" class="animated bounceInRight delay-1s">
          <v-row>
            <v-col cols="12" align="center">
              <company-logo
                :name="$store.getters['company/name']"
                :logo="filesUrl + 'logo/' + $store.getters['company/companySettings'].logo"
              ></company-logo>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-row>
      <v-col cols="12" align="center">
        <v-btn class="animated bounceIn delay-2s" color="primary" @click="shipmentDialog = true">{{$t('suppliersShipments.getShipments')}}</v-btn>
      </v-col>
    </v-row>
    <v-dialog :value="shipmentDialog && step === 4" persistent :width="$store.state.company.data.assemblyMode ? '800px' : '600px'">
      <v-card>
        <v-card-title class="headline primary white--text" dark>
          <v-spacer></v-spacer>
          {{$t('suppliersShipments.stockChangeTitle')}}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-row>
            <template  v-for="supplier in suppliersStock" >
              <v-col :key="supplier.supplier._id" :cols="Math.floor(12 / suppliersStock.length)">
                <stock :init-stock="supplier.initStock" :stock="supplier.stock" :title="supplier.supplier.name" :cols="12"/>
                <p
                  v-if="showIntermediateStock"
                  class="text-center"
                  style="font-size: 20px; font-weight: 900"
                >{{$tc('suppliersShipments.stockChange', supplier.stock, {nbr: supplier.stock})}}</p>
              </v-col>
            </template>
            <stock v-if="shipmentDialog && step === 4" :init-stock="initalStock" :stock="currentStock" :assembly="$store.state.company.data.assemblyMode"></stock>
            <v-col cols="12" align="center">
              <p
                v-if="showStockLabel"
                style="font-size: 26px; font-weight: 900"
              >{{$tc('suppliersShipments.stockChange', this.newStock, {nbr: this.newStock})}}</p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="$store.state.company.loading"
            :disabled="$store.state.company.loading"
            @click="$store.dispatch('company/setStep', 5)"
          >{{$t('general.ok')}}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-stepper-content>
</template>

<script>
import { mapGetters } from "vuex";
import Stock from "@/components/Stock";
import CompanyLogo from "@/components/CompanyLogo";
export default {
  name: "SuppliersShipments",
  components: {
    CompanyLogo,
    Stock
  },
  props: {
    step: Number,
    timeLeft: Number
  },
  data: () => ({
    shipmentDialog: false,
    initalStock: 0,
    newStock: 0,
    currentStock: 0,
    suppliersStock: [],
    showStockLabel: true,
    showIntermediateStock: false
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.suppliersStock = []
      this.shipmentDialog = false;
      this.initalStock =
        this.$store.getters["company/stock"] -
        this.$store.getters["company/data"].value.receipts[
          this.$store.getters["company/data"].value.receipts.length - 1
        ];
      this.newStock = this.$store.getters["company/stock"];
      this.currentStock = this.initalStock;
      if (this.$store.state.company.data.assemblyMode) {
        this.initalStock = this.$store.getters["company/stock"] - this.assemblyItemReceived
        this.showStockLabel = false
        for (const supplier of this.$store.getters['company/data'].suppliers) {
          this.suppliersStock.push({
            supplier: supplier.supplier,
            stock: supplier.stock[supplier.stock.length - 1] - supplier.receipts[supplier.receipts.length - 1] + this.assemblyItemReceived,
            initStock: supplier.stock[supplier.stock.length - 1] - supplier.receipts[supplier.receipts.length - 1] + this.assemblyItemReceived
          })
        }
      }
    },
    stockAnimation() {
      if (this.$store.state.company.data.assemblyMode) {
        setTimeout(() => {
          this.showIntermediateStock = true
          this.suppliersStock.forEach((supplier, index) => {
            supplier.stock = supplier.stock + this.$store.getters['company/data'].suppliers[index].receipts[this.$store.getters['company/data'].suppliers[index].receipts.length - 1]
          });
        }, 500);
        setTimeout(() => {
          this.suppliersStock.forEach((supplier) => {
            supplier.stock = supplier.stock - this.assemblyItemReceived
          });
          this.currentStock = this.newStock
          this.showStockLabel = true
        }, 3000);
      } else {
        setTimeout(() => (this.currentStock = this.newStock), 500);
      }
    }
  },
  computed: {
    assemblyItemReceived () {
      let sum = 0
      for (const supplier of this.$store.getters['company/data'].suppliers) {
        sum = supplier.receipts[supplier.receipts.length - 1] - supplier.stock[supplier.stock.length - 1]
      }
      return sum
    },
    production() {
      return this.$store.getters["company/data"].value.receipts[
        this.$store.getters["company/data"].value.receipts.length - 1
      ];
    },
    
    ...mapGetters("company", {
      filesUrl: "filesUrl"
    })
  },
  watch: {
    shipmentDialog(val) {
      if (val) {
        this.stockAnimation()
      }
    },
    step(val) {
      if (val === 4) {
        this.init();
      }
    }
  }
};
</script>